import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/module/app.config';
import {AppComponent} from './app/module/app.component';
import {environment} from "./environment/environment";
import {enableProdMode} from "@angular/core";
import { Config } from './app/common/config';

if (environment.production) {
  enableProdMode();
}

Config.loadToken();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));